// extracted by mini-css-extract-plugin
export default {"mainLayoutstyle":"MainLayout_mainLayoutstyle__nnCS-","backdrop":"MainLayout_backdrop__7SoeI","content__wrapper":"MainLayout_content__wrapper__FpFxP"};